<div class="timesheet-row timesheet-row--gap">
    <div class="timesheet-row__times">
        @if (!readonly()) {
            <button class="btn btn-sm btn-danger" type="button" (click)="addEntry.emit()">
                {{ 'TIMESHEET_ADD_TIMESLOT_LABEL' | translate }}
            </button>
            @if (canAddTravelBack()) {
                <button class="btn btn-sm btn-primary ms-2" type="button" (click)="addTravelBack.emit()">
                    {{ 'TIMESHEET_ADD_TRAVEL_BACK_LABEL' | translate }}
                </button>
            }
        } @else {
            <span translate="TIMESHEET_ADD_TIMESLOT_LABEL"></span>
        }
    </div>

    <div class="timesheet-row__duration">{{ duration() }}</div>

    <div class="timesheet-row__activity"></div>
    <div class="timesheet-row__meta"></div>
    <div class="timesheet-row__actions"></div>
</div>
